import { Download } from "lucide-react";
import React from "react";
import { ActionIcon } from "@mantine/core";
import moment from "moment";
import { IEmployeeOdpBlockDate } from "../../@types/blockedDates";
import { getBlockedDateEvent } from "../../utils/OdpLimitsUtils";

interface IIndividuaBlockDateEmployeesProps {
  currentBlockDate: IEmployeeOdpBlockDate;
}
const DownloadBlockedEmployees: React.FC<IIndividuaBlockDateEmployeesProps> = ({
  currentBlockDate,
}) => {
  const downloadCSV = (): void => {
    getBlockedDateEvent(currentBlockDate, currentBlockDate.employees).forEach(
      (event) => {
        const element = document.createElement("a");
        const headers = [
          "Full Name",
          "Employee Number",
          "Employee ID",
          "Branch",
        ];
        const csv = [headers.join(",")];
        event.employees?.forEach((employee) => {
          csv.push(
            [
              employee.employee_name,
              employee.employee_number,
              employee.employee_id_number || "",
              employee.employee_branch || "",
            ].join(",")
          );
        });
        const csvString = csv.join("\n");
        element.href = URL.createObjectURL(
          new Blob([csvString], { type: "text/csv" })
        );
        element.download = `${event.title} ${moment(event.start).format(
          "YYYY-MM-DD"
        )} - ${moment(event.end).format("YYYY-MM-DD")} as of ${moment().format(
          "YYYY-MM-DD"
        )}.csv`;
        document.body.appendChild(element);
        element.click();
        element.remove();
      }
    );
  };
  return (
    <ActionIcon
      onClick={downloadCSV}
      size={32}
      classNames={{ root: "border rounded border-jem-primary-50t" }}
    >
      <Download size={16} />
    </ActionIcon>
  );
};

export default DownloadBlockedEmployees;
